import { AnalyticsSender, Offer } from '@funtech-int/yango-shared';

import {
    OnboardingPlusSubscriptionOfferNavigatedV5To,
    onboardingPlusSubscriptionOfferNavigatedV5,
    onboardingPlusSubscriptionOfferShowedV5,
    onboardingPlusSubscriptionOfferSucceedV4,
} from '@kinopoisk-int/evgen-web-events/web/onboarding_plus';
import { OnboardingPlusOfferEntityType } from '@kinopoisk-int/evgen-web-events/web/named_enums';

import { TARIFFICATOR_BILLING_PRODUCT_ID } from '@/shared/lib/analytics/offer';
import { getBillingProductIds, getOfferPositionsData, getOfferTitle } from '@/shared/lib/analytics';

interface SubscriptionOfferAnalyticsParams {
    buttonText: string;
    offer: Offer | null;
    entityType?: string;
}

interface SubscriptionOfferAnalytics {
    showed(this: void): void;
    navigated(this: void): void;
    succeeded(this: void): void;
}

export function createSubscriptionOfferAnalytics(
    eventSender: AnalyticsSender,
    { buttonText, entityType, offer }: SubscriptionOfferAnalyticsParams
): SubscriptionOfferAnalytics {
    const { tariffOffer, optionOffers = [] } = offer?.catalogCompositeOffer || {};
    const { batchId = '', positionId = '' } = offer?.analyticData || {};
    const tariffName = tariffOffer?.name;
    const optionName = optionOffers[0]?.name;

    const offersPositionsData = getOfferPositionsData({
        offersBatchId: batchId,
        offersPositionId: positionId,
    });

    return {
        showed() {
            eventSender.sendOnce(onboardingPlusSubscriptionOfferShowedV5, {
                buttonText,
                offerTitle: getOfferTitle(offer),
                offerTariffName: tariffName ?? '',
                offerOptionNames: optionName ?? '',
                show: offersPositionsData,
                entityType: entityType
                    ? (entityType as OnboardingPlusOfferEntityType)
                    : OnboardingPlusOfferEntityType.SubscriptionOption,
                billingProductId: TARIFFICATOR_BILLING_PRODUCT_ID,
                billingProductIds: getBillingProductIds({
                    tariffOfferName: tariffName,
                    optionOfferNames: optionName,
                }),
            });
        },
        navigated() {
            eventSender.send(onboardingPlusSubscriptionOfferNavigatedV5, {
                buttonText,
                offerTitle: getOfferTitle(offer),
                offerTariffName: tariffName ?? '',
                offerOptionNames: optionName ?? '',
                click: offersPositionsData,
                entityType: OnboardingPlusOfferEntityType.SubscriptionOption,
                billingProductId: TARIFFICATOR_BILLING_PRODUCT_ID,
                billingProductIds: getBillingProductIds({
                    tariffOfferName: tariffName,
                    optionOfferNames: optionName,
                }),
                to: OnboardingPlusSubscriptionOfferNavigatedV5To.Payment,
            });
        },
        succeeded() {
            eventSender.send(onboardingPlusSubscriptionOfferSucceedV4, {
                buttonText,
                offerTitle: getOfferTitle(offer),
                offerTariffName: tariffName ?? '',
                offerOptionNames: optionName ?? '',
                entityType: entityType
                    ? (entityType as OnboardingPlusOfferEntityType)
                    : OnboardingPlusOfferEntityType.SubscriptionOption,
                billingProductId: TARIFFICATOR_BILLING_PRODUCT_ID,
                billingProductIds: getBillingProductIds({
                    tariffOfferName: tariffName,
                    optionOfferNames: optionName,
                }),
            });
        },
    };
}
